/**
 *
 * Asynchronously loads the component for UserInfo
 *
 */

import { lazyLoad } from 'utils/loadable';

export const UserInfo = lazyLoad(
  () => import('./index'),
  module => module.UserInfo,
);
